import styled from 'styled-components';
import List from 'react-chatview';
import { Modal as ModalComponent } from 'react-bootstrap';
import { GridDropZone as GridDropZoneComponent } from 'react-grid-dnd';

interface IGridDropZone {
  height: number;
}

export const Container = styled(List)`
  height: calc(100vh - 61px);

  .box {
    border-radius: 20px;
  }
`;

export const Steps = styled.div`
  hr {
    background-color: #333333;
  }
`;

export const GridDropZone = styled(GridDropZoneComponent)<IGridDropZone>`
  height: ${(props) => (props.height > 0 ? props.height : 200)}px;

  .cursor-grab {
    cursor: grab;
  }

  .cursor-grabbing {
    cursor: grabbing;
  }
`;

export const Module = styled.div`
  position: relative;

  div {
    pointer-events: none;
    border: 1px solid #3a3a3a;
    box-shadow: 0px 13px 19px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }

  button {
    top: 15px;
    right: 30px;
  }
`;

export const Modal = styled(ModalComponent)`
  .modal-content {
    border: none;
    background: #242526;
    border-radius: 10px;
    padding: 1.5rem;

    h4 {
      font-weight: 600;
      color: #ffffff;
    }

    .close {
      font-size: 24px;
      border: none;
      position: absolute;
      top: 20px;
      right: 40px;
      font-size: 30px;
      background: none;

      .sr-only {
        display: none;
      }
    }
  }
`;
